import { render, staticRenderFns } from "./VtipsDialog.vue?vue&type=template&id=1f709d7d&scoped=true&"
import script from "./VtipsDialog.vue?vue&type=script&lang=js&"
export * from "./VtipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./VtipsDialog.vue?vue&type=style&index=0&id=1f709d7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f709d7d",
  null
  
)

export default component.exports